// extracted by mini-css-extract-plugin
export default {"main":"_135b2bc327","tit":"cd68866a3d","maintitle":"d617dcc13f","ylw":"bb7befb7d1","white":"_0aa0ca84c2","mv_title":"cfe07619db","mv_nc":"b981170fb7","mv_in":"d4d511ba04"};